import { useState } from "react"
import "../../styles/pageStyles/dailyRoutineStyles.css"


export default function ChooseRoutineMode(props) {


    const progressionModes = [
        {
            value: "weighted",
            title: "Weighted Triad (most popular)",
            description: "Weighted triad has three rounds of 100 levels. levels 1 - 100: Body weight only; level 101 - 200: light weighted vest, and levles 201 - 300 medium weighted vest."
        },
        {
            value: "tiers",
            title: "Tiers",
            description: `The tiers mode dynamically adjusts the number of exercises as a your level increases.`
        },
        {
            value: "steady_increase",
            title: "Steady Increase",
            description: "Each exercises increase steadily from level 1 to 300."
        },
        {
            value: "own_pace",
            title: "Your Own Pace",
            description: "You decide when you are ready to move up to the next level. You will choose how many reps to start at and when it's time to move on."
        }
    ]

    const handleModeChange = (e) => {
        props.setRoutineFormData(current => ({
            ...current,
            mode: e.target.value,
        }))
        props.setCurrentModeSelectionTitle(e.target.title)
    }

    
    return <div className="routine-wrapper">

        <h2 className="routine-card-title">Creating Routine...</h2>

        <div className="mode-progress-section-wrapper">
            { props.routineFormData.mode &&
                <div>
                    <p>Mode</p>
                    <h3>{props.currentModeSelectionTitle}</h3>
                </div>
            }
        </div>

        <div className="routine-wizard-content-wrapper">
            <p className="wizard-supporting-text">Let's select your progression mode. This determines how your routine changes as you progress through the levels.</p>
            <div className="wizard-inputs-wrapper">
                {progressionModes.map(mode => (
                    
                        <label key={mode.value} className="wizard-input-item">
                            <input 
                                type="radio"
                                name="progressionMode"
                                value={mode.value}
                                title={mode.title}
                                checked={props.routineFormData.mode === mode.value}
                                onChange={handleModeChange}
                            />
                            <div className="mode-radio-descriptions-wrapper">
                                <p className="mode-radio-title">{mode.title}</p>
                                <p className="mode-radio-decription">{mode.description}</p>
                                <p className="radio-learn-more">more info</p>
                            </div>
                        </label>

                ))}
            </div>
            <div className="wizard-progression-btns-wrapper">
                <button 
                className="secondary-btn"
                onClick={props.handleCancelClick}>back</button>
                <button 
                className="secondary-btn"
                disabled={props.routineFormData.mode === ""}
                onClick={() => props.setSetupStep(props.SETUP_STEPS.SUGGESTED)}>next</button>
            </div>
        </div>

        <div className="wizard-save-btns-wrapper">
            <button className="routine-main-button" disabled={true}>Save Routine</button>
            <button className="routine-cancel-btn" onClick={props.handleCancelClick}>cancel</button>
        </div>
    </div>
}